import { Route, Routes } from "react-router-dom";
import { CalculationBasis } from "./list";
import { CreateEngineFiscalRulesState } from "./list/create";

export default function CalculationBasisRoutes() {
  return (
    <Routes>
      <Route path="/" element={<CalculationBasis />} />
      <Route
        path="/criar-base-calculo"
        element={<CreateEngineFiscalRulesState />}
      />
    </Routes>
  );
}
